import { LOCALES } from 'utils/constants';

const translation = {
    [LOCALES.FA]: {
        NO_CONTENT: 'محتوایی یافت نشد!',
        SEARCH: "عبارت خود را جستجو کنید",
    },
    [LOCALES.EN]: {
        NO_CONTENT: "No Content Provided!",
        SEARCH: "Search",
    }
}

export default translation;